import { type FC, useCallback } from "react";
import { type IconProp } from "@fortawesome/fontawesome-svg-core";
import { Select, Toggle } from "@onshopfront/components";
import FontAwesomeLight from "../../../Utilities/Platform/FontAwesome/FontAwesomeLight";
import { type ReportOptionType } from "./DashboardModify";

interface Props {
    report: ReportOptionType | null;
    setReport: (report: ReportOptionType) => void;
    filterUser: boolean;
    setFilterUser: (filterUser: boolean) => void;
    options: Array<ReportOptionType>;
}

export const DashboardModifyItemForm: FC<Props> = ({
    options,
    report,
    setReport,
    filterUser,
    setFilterUser,
}) => {
    const renderValue = useCallback((option: ReportOptionType) => {
        let icon: IconProp = "table";

        const report = option.additional.report;

        if(report.precision && !report.on.length) {
            if(report.precision.type === "range") {
                icon = "chart-line";
            } else if(report.precision.type === "aggregate") {
                icon = "chart-bar";
            }
        }

        return (
            <div className="select-value">
                <FontAwesomeLight icon={icon} className="mr-2" />
                {option.label}
            </div>
        );
    }, []);

    return (
        <div
            className="contents"
            onClick={e => {
                e.stopPropagation();
            }}
        >
            <Select
                value={report}
                options={options}
                renderValue={renderValue}
                renderLabel={renderValue}
                placeholder="Select a report..."
                onChange={(option: ReportOptionType) => {
                    setReport(option);
                }}
                className="w-full max-w-[600px]"
            />
            <label className="flex items-center gap-2 mt-2">
                <Toggle
                    checked={filterUser}
                    onChange={e => {
                        setFilterUser(e.currentTarget.checked);
                    }}
                />
                Filter report by current user
            </label>
        </div>
    );
};
